export default __webpack_public_path__ + "static/media/Davina_Duerr.78cd61c6.jpg";